// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__sgWu7","errorLogs":"styles_errorLogs__2KT8L"};